import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row my-2 col-12 px-5 row g-0" }
const _hoisted_2 = { class: "col-12 row" }
const _hoisted_3 = { class: "form-group col-12 mb-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Pharmacy: ")
const _hoisted_5 = {
  tabindex: "0",
  role: "button"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle text-dark font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row my-2 col-12 px-5 row g-0" }
const _hoisted_9 = { class: "col-12 row" }
const _hoisted_10 = { class: "form-group col-12" }
const _hoisted_11 = { class: "form-group col-12 ps-0" }
const _hoisted_12 = { class: "col-12 px-0" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "form-group mt-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, " Pharmacy: ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormSection, {
      title: "Pharmacy Information",
      "full-height": false,
      "application-id": _ctx.application
    }, {
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("section", null, [
                _createElementVNode("label", null, [
                  _hoisted_4,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, _hoisted_7)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.attendingPharmacyTooltip) }]
                  ])
                ]),
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getPharmacyList,
                  value: _ctx.attendingPharmacy,
                  onValueChanged: _ctx.attendingPharmacyChanged,
                  "init-value": _ctx.attendingPharmacy,
                  placeholder: "Begin typing the pharmacy name"
                }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"]),
                _createElementVNode("button", {
                  class: "btn btn-xs btn-primary m-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newPharmacy()))
                }, "New Pharmacy")
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"]),
    _createVNode(_component_FormSection, {
      title: "Additional Pharmacy",
      "full-height": false,
      "application-id": _ctx.application,
      class: "mt-2"
    }, {
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("section", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalPharmacy, (contact, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, "Additional Pharmacy " + _toDisplayString(index + 1), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "btn table-btn btn-outline-danger me-1 ms-auto",
                          onClick: ($event: any) => (_ctx.removePharmacyContact(index))
                        }, _hoisted_17, 8 /* PROPS */, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getPharmacyList,
                        value: contact.Name,
                        onValueChanged: (e) => _ctx.additonalPharmacyChanged(e, index),
                        "init-value": null,
                        placeholder: "Begin typing the pharmacy name"
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("button", {
                class: "btn btn-xs btn-primary m-0",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addPharmacy()))
              }, "Add Pharmacy")
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"])
  ], 64 /* STABLE_FRAGMENT */))
}